import {InjectionToken} from "@angular/core";
import {IUploadImage} from "@core/component/upload/image.interface";

export const UPLOAD_TOKEN = new InjectionToken<IUploadImage>('ImageUpload')
